import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources, { loadBaseLanguage } from '../locale';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    returnEmptyString: false,
    resources: (resources || []).reduce((all, { key, lng }) => {
      all[key] = lng;
      return all;
    }, {}),
    lng: 'en',
    // Keep language codes lowercase so 'en-us' is not normalized to 'en-US' by i18next,
    // which would cause a lookup miss and fall through to the base 'en' resource instead
    // of our 'en-us' resource. See: https://github.com/i18next/i18next/issues/1506
    lowerCaseLng: true,
    // no explicit separator character used to separate namespaces or keys in the translation keys
    // nsSeparator default value: ':', keySeparator default value: '.'
    keySeparator: false,
    nsSeparator: false,
    fallbackLng: {
      ...(resources || []).reduce((all, { key, fallback }) => {
        all[key] = fallback;
        return all;
      }, {}),
      default: ['en']
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export const ensureBaseLanguageLoaded = async (language) => {
  if (!language || i18n.hasResourceBundle(language, 'translation')) {
    return;
  }
  const languageFile = await loadBaseLanguage(language);
  if (languageFile?.translation) {
    i18n.addResourceBundle(language, 'translation', languageFile.translation, true, true);
  }
};
